<template>
  <div>
     <water-view :items="state.items"></water-view>
  </div>
</template>
<script setup>
import WaterView from '@/components/WaterView.vue';
import img01 from '@/assets/images/other/huodng21.png'
import img02 from '@/assets/images/other/huodng22.png'
import img03 from '@/assets/images/other/huodng03.png'
import img05 from '@/assets/images/other/huodng05.png'
import img06 from '@/assets/images/other/huodng06.png'
import img07 from '@/assets/images/other/huodng07.png'
import img08 from '@/assets/images/other/huodng08.png'
import img10 from '@/assets/images/other/huodng10.png'
import img11 from '@/assets/images/other/huodng11.png'


import { reactive } from 'vue-demi';
const state = reactive({
  items:[
    {
            key: 'xxh3',
            img: img01
          },
          {
            key: '5xx3',
            img: img02
          },
          {
            key: 'xx3',
            img: img03
          },
          {
            key: 'xx05',
            img: img05
          },
          {
            key: 'xx06',
            img: img06
          },
          {
            key: 'xx07',
            img: img07
          },
          {
            key: 'xx0GF8',
            img: img08
          },
          {
            key: 'xx05GD',
            img: img10
          },
          {
            key: 'xx0444',
            img: img11
          }
  ]
})
</script>
<style lang="less" scoped>

</style>